import { z } from 'zod';
/** Max results returned per group (screens / playlists / media). */
export const SEARCH_RESULTS_PER_GROUP = 5;
export const SearchQuerySchema = z.object({
    q: z.string().trim().min(1).max(100),
});
export const SearchScreenHitSchema = z.object({
    id: z.string().min(1),
    name: z.string(),
});
export const SearchPlaylistHitSchema = z.object({
    id: z.string().min(1),
    name: z.string(),
});
export const SearchMediaHitSchema = z.object({
    id: z.string().min(1),
    name: z.string(),
    kind: z.enum(['image', 'video']),
});
/** Organisation-wide name search across screens, library playlists, and media. */
export const SearchResultsSchema = z.object({
    screens: z.array(SearchScreenHitSchema),
    playlists: z.array(SearchPlaylistHitSchema),
    media: z.array(SearchMediaHitSchema),
});
//# sourceMappingURL=search.js.map